<template lang="html">
  <div class="h-100 pa3">
    <div class="tc pl-title mb3">The RoundTable Prompt</div>
    <div class="mh3 pa3 flex-grow">
      <div class="flex justify-center mb2">
        <img
          src="/static/online_roundtable_icons/browse_universe_icon.svg"
          class="ma3"
        />
        <img
          src="/static/online_roundtable_icons/from_scratch.svg"
          class="ma3"
        />
      </div>
      <p class="pl-subheading tl">
        Browse the Parlay Universe to discover a discussion prompt for your
        students. You can edit the content to suit your needs, or create a brand
        new topic from scratch.
      </p>
    </div>
    <div class="flex justify-center">
      <pl-button @click.native="$emit('close')" class="pl-primary">
        Got it!
      </pl-button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// onlineWalkthroughPrompt.vue?4ae0ea1d